import useSauna, { type SaunaRefetchIntervalFn } from '@/features/homeAutomation/hooks/useSauna';

import type { SaunaWidgetConfig } from './config';

const FAST_POLL_MS = 15_000;
const FAST_PHASES = new Set(['warming', 'ready']);

export default function useSaunaWidgetData(config: SaunaWidgetConfig) {
  const baseIntervalMs = config.pollSeconds * 1000;
  const refetchInterval: SaunaRefetchIntervalFn = (query) => {
    const phase = query.state.data?.currentState?.phase;
    if (phase && FAST_PHASES.has(phase)) return Math.min(FAST_POLL_MS, baseIntervalMs);
    return baseIntervalMs;
  };
  return useSauna(config.homeId ?? undefined, { refetchInterval });
}
